// Supabase Configuration
// Get these values from: https://app.supabase.com → Your Project → Settings → API
// 
// 1. Go to https://app.supabase.com
// 2. Create a new project (or use existing)
// 3. Go to Settings → API
// 4. Copy your Project URL and anon/public key

import { createClient } from '@supabase/supabase-js';

// Use environment variables for security (fallback to hardcoded for local dev)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://zefszhpmtvgnzpbddmyw.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InplZnN6aHBtdHZnbnpwYmRkbXl3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM0MTc5MjYsImV4cCI6MjA3ODk5MzkyNn0.vpcw2DGZcEgzx_49FbYpS0A7DxsC362eOtXOOHJpUDk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/*
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://zefszhpmtvgnzpbddmyw.supabase.co'
const supabaseKey = process.env.SUPABASE_KEY
const supabase = createClient(supabaseUrl, supabaseKey)
*/